import { Button, Input } from 'ui';
import { Form } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useCartState } from "../../../context/CartContext";
import { CouponDiscounts } from "../../../../interfaces/Coupon";
import { useTranslations } from "../../../../admin/pages/Coupons/hooks/use-translations";
import { useCoupons } from "./useCoupons";

export default function CouponManager() {
  const t = useTranslations()
  const { farmProducts } = useCartState();
  const { code, setCode, applyCoupon, removeCoupon, coupons, validating } = useCoupons();

  const getCouponTotalDiscount = (coupon: CouponDiscounts) => {
    return farmProducts.flatMap(farm => farm.products)
      .reduce((sum, prod) => {
        const productId = prod.cartProduct?.id;
        return productId
          ? sum + (coupon.productDiscounts?.[productId] ?? 0) * prod.amount
          : sum;
      }, 0)
  }

  return (
    <div className="cart-farm-order-summary coupon">
      <Form.Item label={t('cart_summary.coupon.label')}>
        <Input
          value={code}
          onChange={e => setCode(e.target.value)}
        />
        <Button
          className={'ant-btn ant-btn-primary coupon-btn'}
          onClick={applyCoupon}
          loading={validating}
          disabled={validating}
          label={t('cart_summary.coupon.apply')}
        />
      </Form.Item>

      {coupons.filter(c => getCouponTotalDiscount(c) > 0).length > 0 && (
        <div className="applied-coupons">
          {coupons.map(c => (
            <div key={'coupon_code_' + c.code} className="applied-coupon">
              <span>
                {t('cart_summary.coupon.title')}:
                <b>{getCouponTotalDiscount(c).toFixed(2)} €</b>
              </span>
              <Button
                className={'ant-btn ant-btn-primary coupon-btn'}
                onClick={() => removeCoupon(c.code)}
                loading={validating}
                disabled={validating}
                label={t('cart_summary.coupon.remove')}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
